import { render } from "./newcountry.vue?vue&type=template&id=a9efc376"
import script from "./newcountry.vue?vue&type=script&lang=js"
export * from "./newcountry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__